import { create } from "zustand";

const STORAGE_KEY = "ld_theme";

export type SystemTheme = "dark" | "light" | "system";

function loadSystemTheme(): SystemTheme {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "dark" || v === "light" || v === "system") return v;
  } catch (_) {}
  return "system";
}

interface ThemeStore {
  systemTheme: SystemTheme;
  setSystemTheme: (theme: SystemTheme) => void;
}

export const useThemeStore = create<ThemeStore>((set) => ({
  systemTheme: loadSystemTheme(),
  setSystemTheme: (theme) => {
    localStorage.setItem(STORAGE_KEY, theme);
    set({ systemTheme: theme });
  },
}));
